<template>
    <layout-card :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :type="settings.context"
        @edit-card="toggleSettingsForm"
        :error="error"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
        class="card-pur_invoice"
        >
        <template slot="title">
            {{ name }}
        </template>
        
        <template slot="content">
            <template-kpi-card :data="{'stats':cardData, 'labels': labels}" />
            <div id="rates" class="mt-3 bt-1" :class="[ ifMultiRate() ? 'pt-1' : 'pt-3' ]" v-if="cardData">
                <div class="mt-1 pt-1" v-for="(rate, index) in cardData.rates" :key="index">
                    <h3 class="stats-title mb-2">{{ index === "marginRate" ? $l10n.__('Taux de marge moyen') : $l10n.__('Taux de marque moyen') }}</h3>
                    <div class="data-block-number">
                        <h3 :class="[ ifMultiRate() ? 'stats-title' : 'data-value' ]">{{ rate | numberformat }} % </h3>
                    </div>
                </div>
            </div>
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>

        <template slot="footer">
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>
    </layout-card>
</template>

<script>
    import LayoutCard from './LayoutCard.vue'
    import TemplateKpiCard from './TemplateKpiCard.vue'
    import CardMixin from './CardMixin.js';
    import FiscalYearFooter from './FiscalYearFooter.vue'

    export default {
        mixins : [CardMixin],
        data() {
            return {
                labels: {
                    due: {
                        label: this.$l10n.__("À régler"),
                        labelCount: this.$l10n.__("Factures")
                    }
                },
                settingsFormName : 'pur-invoice-setting-form'
            }
        },
        methods : {
            ifMultiRate() {
                return Object.keys(this.cardData.rates).length >= 2
            }
        },
        components: {
            LayoutCard,
            TemplateKpiCard,
            FiscalYearFooter,
        },
    }
</script>